import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

//ROTAS PADRÃO DO SISTEMA. 
var routes = [
  {
    path: '/',
    name: 'Home',
    meta: {
      reload: true,
    },
    component: () => import(/* webpackChunkName: "about" */ '@/pages/Home.vue')
  },
  {
    path: '/solicitacoes',
    name: 'Solicitacoes',
    component: () => import(/* webpackChunkName: "about" */ '@/pages/Solicitacoes.vue')
  }, 
  {
    path: '/admLogin',
    name: 'AdmLogin',
    component: () => import(/* webpackChunkName: "about" */ '@/pages/AdmLogin.vue')
  }, 
  {
    path: '/admPainel',
    name: 'AdmPainel',
    component: () => import(/* webpackChunkName: "about" */ '@/pages/AdmPainel.vue')
  },
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page

  const publicPages = ['/Home'];
   

  next();
})

export default router
